import { Loader2 } from "lucide-react";

const VARIANTS = {
  primary: "bg-blue-600 hover:bg-blue-500 text-white shadow-lg shadow-blue-600/20",
  accent: "bg-gradient-to-r from-blue-600 to-sky-500 hover:from-blue-500 hover:to-sky-400 text-white shadow-md",
  secondary: "bg-slate-800 hover:bg-slate-700 text-slate-200 border border-white/10",
  ghost: "text-slate-300 hover:bg-white/5",
  destructive: "bg-red-500/10 hover:bg-red-500/20 text-red-400 border border-red-500/30",
};

export function Button({ variant = "primary", loading, children, className = "", full, ...props }) {
  return (
    <button
      {...props}
      disabled={props.disabled || loading}
      className={`inline-flex items-center justify-center gap-2 font-medium rounded-xl px-4 py-2.5 text-sm
        active:scale-95 transition-all focus:outline-none focus:ring-2 focus:ring-sky-400 disabled:opacity-50
        disabled:pointer-events-none ${VARIANTS[variant]} ${full ? "w-full" : ""} ${className}`}
    >
      {loading && <Loader2 className="animate-spin" size={16} />}
      {children}
    </button>
  );
}
